module.exports = __webpack_public_path__ + "static/media/extrafina_salmantina_deusto.7d31aadb.png";